/**
 * Roles centralizados según is_admin y teams asignados:
 * - Admin: is_admin y sin teams → acceso total
 * - Manager: is_admin y con teams → acceso a su equipo
 * - Basic: no admin y con teams → acceso limitado a su equipo
 * - Sin acceso: no admin y sin teams → no puede usar la app (403 en backend)
 */

export const ROLE_ADMIN = 'admin';
export const ROLE_MANAGER = 'manager';
export const ROLE_BASIC = 'basic';

/**
 * @param {{ is_admin?: boolean, teams?: string[] } | null} user
 * @returns {'admin'|'manager'|'basic'|null} null si no hay user o no tiene acceso
 */
export function getRole(user) {
  if (!user) return null;
  const hasTeams = Array.isArray(user.teams) && user.teams.length > 0;
  if (user.is_admin && !hasTeams) return ROLE_ADMIN;
  if (user.is_admin && hasTeams) return ROLE_MANAGER;
  if (!user.is_admin && hasTeams) return ROLE_BASIC;
  return null; // no admin y sin teams → backend devuelve 403
}

export function isAdmin(role) {
  return role === ROLE_ADMIN;
}

export function isManager(role) {
  return role === ROLE_MANAGER;
}

export function isBasic(role) {
  return role === ROLE_BASIC;
}

/** Admin o Manager pueden gestionar usuarios de su ámbito */
export function canManageUsers(role) {
  return role === ROLE_ADMIN;
}

export function canManageTeams(role) {
  return role === ROLE_ADMIN;
}

export function canManageVacations(role) {
  return role === ROLE_ADMIN || role === ROLE_MANAGER;
}

export function canViewJiraDashboard(role) {
  return role === ROLE_ADMIN || role === ROLE_MANAGER;
}

export function canManageConfig(role) {
  return role === ROLE_ADMIN;
}

/** Admin ve todos los equipos; Manager/Basic solo los suyos */
export function scopeTeams(user) {
  if (!user?.teams?.length) return null; // todos (solo Admin)
  return user.teams;
}
